<template>
    <div style="padding: 5px; border-radius: 3px; margin-top: 30px;">
        <div style="margin: 5px;">
            <h5><b>{{ item.product_sku }}</b></h5>
            <b-button size="sm">Mark as Pulled</b-button>
            <div v-for="element, idx in item.elements" style="font-size: 15px; margin: 5px; border: 1px solid black;">
                <div style="display: inline-block; margin: 5px; background: #efefef;">{{ element.product_sku }} X {{ element.approved_quantity }}</div>
    
                <div style="display: inline-block; margin: 5px; background: yellow; padding: 5px;">Scanned: {{ (element.pulled_quantity || 0)}}</div>

                <div style="display: inline-block; margin: 5px; background: lightblue; padding: 5px;">Approved: {{ (element.approved_quantity || 0)}}</div>

                <div style="display: inline-block; margin: 5px;"><b-button size="sm" variant="success" @click="scanItem">Scan</b-button></div>
            </div>
        </div>
    </div>
</template>

<script>
    import Requestor from "@/utilities/Requestor"
    export default {
        name: "TRTemplateForItemToPull",
        props: ["viewdata"],
        data: function(){
            return {
                item: {},
                packet: {},
                global_vars: {}
            }
        },
        methods:{

        },
        created: function(){
            let viewdata = this.viewdata;
            this.item = viewdata.item;
            this.packet = viewdata.packet;
            this.global_vars = viewdata.global_vars
        }
    }
</script>

<style scoped>
    .td-custom-1 {
        border: 1px solid black;
        color: black;

    }
</style>


// WEBPACK FOOTER //
// src/components/importables/TRTemplateForItemToPull.vue